import { TourStep } from '../contexts/TourContext';

export const dashboardTourSteps: TourStep[] = [
  {
    target: '[data-tour="dashboard-header"]',
    title: 'Welcome to SimplyPayroll!',
    content:
      "This is your dashboard where you can see an overview of your 1099 contractor payroll activity. Let's take a quick tour to get you started.",
    placement: 'bottom',
  },
  {
    target: '[data-tour="profile-alert"]',
    title: 'Complete Your Profile',
    content:
      "First, you'll need to complete your business profile. This includes your company information, tax details, and payroll settings.",
    placement: 'bottom',
  },
  {
    target: '[data-tour="add-payee-btn"]',
    title: 'Add Contractors',
    content:
      "Once your profile is set up, start by adding your 1099 contractors. You'll need their basic information and tax details.",
    placement: 'bottom',
  },
  {
    target: '[data-tour="new-timesheet-btn"]',
    title: 'Track Hours',
    content:
      'Use the timesheet feature to record hours worked by your contractors. This automatically calculates their payments.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="sidebar-nav"]',
    title: 'Navigation Menu',
    content:
      'Use the sidebar to navigate between different sections: Payees, Timesheets, Tax Information, and 1099 Records.',
    placement: 'right',
  },
];

export const sidebarTourSteps: TourStep[] = [
  {
    target: '[data-tour="nav-payees"]',
    title: 'Manage Contractors',
    content:
      'Add, edit, and manage your 1099 contractors. This is where you store their contact and tax information.',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-timesheets"]',
    title: 'Record Work Hours',
    content:
      'Submit weekly timesheets for each contractor. Hours are automatically calculated into payments.',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-tax-info"]',
    title: 'View Payment Summaries',
    content:
      'See annual payment summaries for contractors earning $600+ and issue 1099 forms.',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-1099-records"]',
    title: 'Manage 1099 Forms',
    content:
      'View, correct, and manage all issued 1099 forms. This is where you handle corrections and voids.',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-profile"]',
    title: 'Business Settings',
    content:
      'Update your business information, tax settings, and payroll configuration.',
    placement: 'right',
  },
];

export const workflowTourSteps: TourStep[] = [
  {
    target: '[data-tour="dashboard-header"]',
    title: 'SimplyPayroll Workflow',
    content:
      "Let's walk through the typical workflow for managing 1099 contractor payroll.",
    placement: 'bottom',
  },
  ...dashboardTourSteps.slice(1), // Skip the welcome step
  ...sidebarTourSteps,
  {
    target: '[data-tour="dashboard-stats"]',
    title: 'Track Your Progress',
    content:
      'Your dashboard shows key metrics like total payments, active contractors, and recent activity to help you stay on top of your payroll.',
    placement: 'top',
  },
];

export const quickStartSteps: TourStep[] = [
  {
    target: '[data-tour="profile-alert"]',
    title: 'Quick Start Guide',
    content: 'New to SimplyPayroll? Follow these steps to get started quickly.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="nav-profile"]',
    title: 'Step 1: Complete Profile',
    content:
      'Click here to set up your business information, including company details and tax settings.',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-payees"]',
    title: 'Step 2: Add Contractors',
    content:
      'Add your first contractor with their contact information and tax details (W-9 form info).',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-timesheets"]',
    title: 'Step 3: Submit Hours',
    content:
      'Record weekly work hours for your contractors to track their earnings.',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-tax-info"]',
    title: 'Step 4: Generate 1099s',
    content:
      'When ready, issue 1099 forms for contractors who earned $600+ in the tax year.',
    placement: 'right',
  },
];

const tourSteps = {
  dashboard: dashboardTourSteps,
  sidebar: sidebarTourSteps,
  workflow: workflowTourSteps,
  quickStart: quickStartSteps,
};

export default tourSteps;
